import type { CookiesBannerVariables } from 'cookies/types'
import { featureFlagKeys } from 'feature-flags/constants/featureFlags'
import { useFeatureFlag } from 'feature-flags/hooks/useFeatureFlag/useFeatureFlag'

export const useCookiesFeatureFlag = () =>
	useFeatureFlag<CookiesBannerVariables>(featureFlagKeys.CookiesBanner)
